import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PromotionFormPage } from './promotion-form.page';

const routes: Routes = [
  {
    path: '',
    component: PromotionFormPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PromotionFormPageRoutingModule {}
